import { put, takeLatest, call } from "redux-saga/effects";
import Api from "./api";
import {
  VENDOR_PROFILE_ACTION,
  VENDOR_PROFILE_LOADING,
  VENDOR_PROFILE_SUCCESS,
  VENDOR_PROFILE_ERROR,
  VENDOR_TRANSACTIONS_ACTION,
  VENDOR_TRANSACTIONS_LOADING,
  VENDOR_TRANSACTIONS_SUCCESS,
  VENDOR_TRANSACTIONS_ERROR,
  VENDOR_OVERVIEW_ACTION,
  VENDOR_OVERVIEW_LOADING,
  VENDOR_OVERVIEW_SUCCESS,
  VENDOR_OVERVIEW_ERROR,
  VENDOR_SETTLEMENTS_ACTION,
  VENDOR_SETTLEMENTS_LOADING,
  VENDOR_SETTLEMENTS_SUCCESS,
  VENDOR_SETTLEMENTS_ERROR,
  VENDOR_QR_CODE_ACTION,
  VENDOR_QR_CODE_LOADING,
  VENDOR_QR_CODE_SUCCESS,
  VENDOR_QR_CODE_ERROR,
  UPDATE_DISCOUNT_PERCENTAGE_ACTION,
  UPDATE_DISCOUNT_PERCENTAGE_LOADING,
  UPDATE_DISCOUNT_PERCENTAGE_SUCCESS,
  UPDATE_DISCOUNT_PERCENTAGE_ERROR,
  DOWNLOAD_QR_CODE_ACTION,
  DOWNLOAD_QR_CODE_LOADING,
  DOWNLOAD_QR_CODE_SUCCESS,
  DOWNLOAD_QR_CODE_ERROR,
  UPDATE_VENDOR_PROFILE_ACTION,
  UPDATE_VENDOR_PROFILE_LOADING,
  UPDATE_VENDOR_PROFILE_SUCCESS,
  UPDATE_VENDOR_PROFILE_ERROR,
} from "./types";

function* getVendorProfileSaga() {
  yield put({ type: VENDOR_PROFILE_LOADING });
  try {
    let res = yield call(Api.getVendorProfile);
    if (res.message) {
      yield put({ type: VENDOR_PROFILE_ERROR, payload: res.message });
    } else {
      yield put({ type: VENDOR_PROFILE_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: VENDOR_PROFILE_ERROR, payload: error.message });
  }
}

function* getVendorTransactionsSaga(data) {
  yield put({ type: VENDOR_TRANSACTIONS_LOADING });
  try {
    let res = yield call(Api.getVendorTransactions, data.payload);
    if (res.message) {
      yield put({ type: VENDOR_TRANSACTIONS_ERROR, payload: res.message });
    } else {
      // Store full paginated response
      yield put({ type: VENDOR_TRANSACTIONS_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: VENDOR_TRANSACTIONS_ERROR, payload: error.message });
  }
}

function* getVendorOverviewSaga(data) {
  yield put({ type: VENDOR_OVERVIEW_LOADING });
  try {
    let res = yield call(Api.getVendorOverview, data.payload);
    if (res.message) {
      yield put({ type: VENDOR_OVERVIEW_ERROR, payload: res.message });
    } else {
      yield put({ type: VENDOR_OVERVIEW_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: VENDOR_OVERVIEW_ERROR, payload: error.message });
  }
}

function* getVendorSettlementsSaga(data) {
  yield put({ type: VENDOR_SETTLEMENTS_LOADING });
  try {
    let res = yield call(Api.getVendorSettlements, data.payload);
    if (res.message) {
      yield put({ type: VENDOR_SETTLEMENTS_ERROR, payload: res.message });
    } else {
      // Store full paginated response
      yield put({ type: VENDOR_SETTLEMENTS_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: VENDOR_SETTLEMENTS_ERROR, payload: error.message });
  }
}

function* getVendorQRCodeSaga() {
  yield put({ type: VENDOR_QR_CODE_LOADING });
  try {
    let res = yield call(Api.getVendorQRCode);
    if (res.message) {
      yield put({ type: VENDOR_QR_CODE_ERROR, payload: res.message });
    } else {
      yield put({ type: VENDOR_QR_CODE_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: VENDOR_QR_CODE_ERROR, payload: error.message });
  }
}

function* updateDiscountPercentageSaga(data) {
  yield put({ type: UPDATE_DISCOUNT_PERCENTAGE_LOADING });
  try {
    let res = yield call(Api.updateDiscountPercentage, data.payload);
    if (res.message) {
      yield put({
        type: UPDATE_DISCOUNT_PERCENTAGE_ERROR,
        payload: res.message,
      });
    } else {
      yield put({
        type: UPDATE_DISCOUNT_PERCENTAGE_SUCCESS,
        payload: res.data,
      });
    }
  } catch (error) {
    yield put({
      type: UPDATE_DISCOUNT_PERCENTAGE_ERROR,
      payload: error.message,
    });
  }
}

function* downloadQRCodeSaga() {
  yield put({ type: DOWNLOAD_QR_CODE_LOADING });
  try {
    let res = yield call(Api.downloadQRCode);
    if (res.message) {
      yield put({ type: DOWNLOAD_QR_CODE_ERROR, payload: res.message });
    } else {
      yield put({ type: DOWNLOAD_QR_CODE_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_QR_CODE_ERROR, payload: error.message });
  }
}

function* updateVendorProfileSaga(data) {
  yield put({ type: UPDATE_VENDOR_PROFILE_LOADING });
  try {
    let res = yield call(Api.updateVendorProfile, data.payload);
    if (res.message) {
      yield put({ type: UPDATE_VENDOR_PROFILE_ERROR, payload: res.message });
    } else {
      yield put({ type: UPDATE_VENDOR_PROFILE_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: UPDATE_VENDOR_PROFILE_ERROR, payload: error.message });
  }
}

function* watchVendorDashboardAsync() {
  yield takeLatest(VENDOR_PROFILE_ACTION, getVendorProfileSaga);
  yield takeLatest(VENDOR_TRANSACTIONS_ACTION, getVendorTransactionsSaga);
  yield takeLatest(VENDOR_OVERVIEW_ACTION, getVendorOverviewSaga);
  yield takeLatest(VENDOR_SETTLEMENTS_ACTION, getVendorSettlementsSaga);
  yield takeLatest(VENDOR_QR_CODE_ACTION, getVendorQRCodeSaga);
  yield takeLatest(
    UPDATE_DISCOUNT_PERCENTAGE_ACTION,
    updateDiscountPercentageSaga
  );
  yield takeLatest(DOWNLOAD_QR_CODE_ACTION, downloadQRCodeSaga);
  yield takeLatest(UPDATE_VENDOR_PROFILE_ACTION, updateVendorProfileSaga);
}

export default watchVendorDashboardAsync;

